import styled from "styled-components"

export const CategoryListStyled = styled.div`
  ul {
    padding: 0;
  }
`
